import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Lottie from "react-lottie";
import mastercard from "../../assets/images/mastercard.png";
import visacard from "../../assets/images/visa.png";
import iyzico from "../../assets/images/iyzico.png";
import "./Subscription.css";

class Subsciption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        cardHolderName: "",
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvc: "",
        refCode: "",
        prodRefCode: "",
      },
      showCard: false,
      selectedInterval: "MONTHLY",
      currentPayment: null,
      proProduct: null,
      isLoad: true,
      loading: false,
      checked: false
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getSubsripstions();
  }
  getSubsripstions = async () => {
    try {
      const response = await apiCall('business/iyzico/get-products','get',null);
      const products = response.products || [];
      // Pro ürünü bul (name === "Pro" veya en son eklenen)
      const proProduct = products.find(p => p.name === 'Pro') || products[products.length - 1];
      this.setState({
        proProduct: proProduct,
        currentPayment: response.payment?.payment
      }, () => {
        this.setState({isLoad: false});
      });
    } catch (e) {
      console.log(e);
      this.setState({isLoad: false});
    }
  }
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };
  handleCheckedChange = (checked) => {
    this.setState({ checked, selectedInterval: checked ? "YEARLY" : "MONTHLY" });
  };
  handleSelectPlan = (referenceCode, prodRefCode) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        refCode: referenceCode,
        prodRefCode: prodRefCode
      },
      showCard: true
    }), () => {
      setTimeout(() => {
        const paymentCard = document.querySelector('.payment-card');
        if (paymentCard) {
          const yOffset = -100;
          const y = paymentCard.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 300);
    });
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    const { formData } = this.state;
    try {
      const resposne = await apiCall('business/iyzico/create-subscripstion-and-payment','post',formData);
      await this.updateUserInfo();
      this.setState({loading: false});
      mainHelper.toastMessage(resposne.status,resposne.message)
    } catch (e) {
      console.log(e);
      this.setState({loading: false});
    }
  }
  updateUserInfo = async () => {
    let user = JSON.parse(localStorage.getItem('user'));
    try {
      const resposne = await apiCall('business/user/get-info-by-id/'+user.id,'get');
      localStorage.setItem('user',JSON.stringify(resposne));
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const boxOption = {
      loop: true,
      autoplay: true,
      animationData: require('../../assets/assets/premium.json'),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };
    const { proProduct, formData, loading, selectedInterval, checked, currentPayment } = this.state;
    const numbers = Array.from({ length: 12 }, (_, i) => i + 1);
    const years = Array.from({ length: 35 - 25 + 1 }, (_, i) => 25 + i);

    let selectedPlan = null;
    let proFeatures = [];
    if (proProduct) {
      const plans = JSON.parse(proProduct.pricingPlans || '[]');
      selectedPlan = plans.find(p => p.paymentInterval === selectedInterval) || plans[0];
      proFeatures = (proProduct.description || '').split(',').map(f => f.trim()).filter(Boolean);
    }

    const hasActiveSubscription = currentPayment && currentPayment.subscriptionStatus === 'ACTIVE';

    return (
      <div
        className="subscription-page-modern"
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Pro Abonelik"
                Breadcrumb={[
                  {name: "Ayarlar", navigate: ""},
                  {name: "Üyelik", navigate: "settings/subscription/detail"},
                  {name: "Pro Abonelik", navigate: ""},
                ]}
            />

            <form id="paymentForm" onSubmit={this.handleSubmit}>
              {/* Modern Header */}
              <div className="row clearfix justify-content-center">
                <div className="col-lg-12">
                  <div className="modern-pricing-header-section">
                    <div className="header-content">
                      <div className="lottie-animation-wrapper">
                        <Lottie options={boxOption} height={120} width={120}/>
                      </div>
                      
                      <h2 className="main-heading">
                        <span className="gradient-text">ServiceZone Pro ile Tüm Özelliklere Erişin</span>
                      </h2>
                      
                      <p className="sub-heading">
                        Tek paket, sınırsız özellik. İşletmenizi bir üst seviyeye taşıyın.
                      </p>

                      {/* Yıllık indirim banner */}
                      <div className="discount-banner">
                        <div className="banner-icon">
                          <i className="fa fa-gift"></i>
                        </div>
                        <div className="banner-content">
                          <h3 className="banner-title">Yıllık Planda Tasarruf!</h3>
                          <p className="banner-text">
                            Yıllık abonelikte aylık <span className="highlight">₺450</span>'ye düşen fiyatla <span className="highlight">₺588 tasarruf</span> edin
                            <span className="emoji-badge">💰</span>
                          </p>
                        </div>
                      </div>

                      {/* Features */}
                      <div className="features-highlight">
                        <div className="feature-badge">
                          <i className="fa fa-check-circle"></i>
                          <span>Sınırsız Kullanıcı</span>
                        </div>
                        <div className="feature-badge">
                          <i className="fa fa-check-circle"></i>
                          <span>Sınırsız Şube</span>
                        </div>
                        <div className="feature-badge">
                          <i className="fa fa-robot"></i>
                          <span>AI Yardımcısı</span>
                        </div>
                        <div className="feature-badge">
                          <i className="fa fa-headphones"></i>
                          <span>7/24 Destek</span>
                        </div>
                      </div>

                      {/* Billing Toggle */}
                      <div className="billing-cycle-compact">
                        <div className="cycle-selector">
                          <button 
                            type="button"
                            className={`cycle-btn ${!checked ? 'active' : ''}`}
                            onClick={() => this.handleCheckedChange(false)}
                          >
                            <span className="cycle-icon">📅</span>
                            <span className="cycle-text">Aylık</span>
                          </button>
                          <button 
                            type="button"
                            className={`cycle-btn ${checked ? 'active' : ''}`}
                            onClick={() => this.handleCheckedChange(true)}
                          >
                            <span className="cycle-icon">🎯</span>
                            <span className="cycle-text">Yıllık</span>
                            <span className="discount-chip">Tasarruf!</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Single Pro Card */}
              <div className="row clearfix modern-pricing-grid justify-content-center">
                {proProduct && selectedPlan ? (
                  <div className="col-lg-6 col-md-8">
                    <div className={`card modern-pricing-card popular-card ${formData.refCode === selectedPlan.referenceCode ? 'selected-card' : ''}`}>
                      <div className="popular-badge-top">Pro</div>
                      <div className="body">
                        <div className="card-icon-container">
                          <Lottie options={boxOption} height={120} width={120}/>
                        </div>
                        
                        <div className="pricing-plan modern-plan">
                          <h2 className="modern-pricing-header" style={{color: '#1d75bd'}}>
                            Pro
                          </h2>
                          
                          <div className="price-wrapper">
                            {selectedInterval === "YEARLY" && (
                              <div className="old-price">
                                {new Intl.NumberFormat("tr-TR", {
                                  style: "currency",
                                  currency: "TRY",
                                  minimumFractionDigits: 0,
                                }).format(499 * 12)}
                              </div>
                            )}
                            
                            <div className="current-price" style={{color: '#1d75bd'}}>
                              {new Intl.NumberFormat("tr-TR", {
                                style: "currency",
                                currency: "TRY",
                                minimumFractionDigits: 0,
                              }).format(selectedPlan.price)}
                            </div>
                            
                            <div className="price-period">
                              / {selectedInterval === "MONTHLY" ? "ay" : "yıl"}
                            </div>
                            
                            {selectedInterval === "YEARLY" && (
                              <div className="monthly-equivalent">
                                💰 Aylık sadece {new Intl.NumberFormat("tr-TR", {
                                  style: "currency",
                                  currency: "TRY",
                                  minimumFractionDigits: 0,
                                }).format(Math.round(selectedPlan.price / 12))}
                              </div>
                            )}
                          </div>

                          <ul className="modern-features-list">
                            {proFeatures.map((f, idx) => (
                              <li key={idx} className="feature-item-modern">
                                <i className="fa fa-check-circle feature-check" style={{color: '#1d75bd'}}></i>
                                <span>{f}</span>
                              </li>
                            ))}
                          </ul>
                          
                          {hasActiveSubscription ? (
                            <div className="alert alert-success text-center" style={{borderRadius: '12px'}}>
                              <i className="fa fa-check-circle mr-2"></i>
                              Aktif Pro Aboneliğiniz Bulunmaktadır
                            </div>
                          ) : (
                            <button
                              type="button"
                              className={`btn modern-select-btn ${formData.refCode === selectedPlan.referenceCode ? 'selected' : ''}`}
                              style={{
                                '--card-color': '#1d75bd',
                                background: formData.refCode === selectedPlan.referenceCode ? '#1d75bd' : 'transparent',
                                borderColor: '#1d75bd',
                                color: formData.refCode === selectedPlan.referenceCode ? 'white' : '#1d75bd',
                              }}
                              onClick={() =>
                                this.handleSelectPlan(
                                  selectedPlan.referenceCode,
                                  selectedPlan.productReferenceCode
                                )
                              }
                            >
                              {formData.refCode === selectedPlan.referenceCode ? (
                                <>
                                  <i className="fa fa-check-circle mr-2"></i>
                                  Seçildi
                                </>
                              ) : (
                                <>
                                  Hemen Başla
                                  <i className="fa fa-arrow-right ml-2"></i>
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-warning text-center">
                    Pro paket yüklenirken bir sorun oluştu.
                  </div>
                )}
              </div>

              {/* Payment Form */}
              {!hasActiveSubscription && (
                <div className="row clearfix justify-content-center">
                  <div className="col-lg-12">
                    <div className={`card payment-card ${this.state.showCard ? 'show' : ''}`}>
                      <div className="body text-center">
                        <h6><i className="icon-credit-card"></i></h6>
                        <h6>Ödeme Bilgileri</h6>
                        <p>
                          <img alt="" className="m-r-5" src={mastercard}/>
                          <img alt="" className="m-r-5" src={visacard}/>
                          <img alt="" className="m-r-5" src={iyzico} style={{width: '100px', height: '32px'}}/>
                        </p>
                        <div className="col-lg-12 d-flex justify-content-center">
                          <div className="col-lg-7 col-md-12">
                            <div className="modern-payment-form">
                              <div className="form-section">
                                <h5 className="section-title">
                                  <i className="fa fa-credit-card"></i> Kart Bilgileri
                                </h5>
                                
                                <div className="modern-form-group">
                                  <label className="modern-label">Kart Üzerindeki İsim</label>
                                  <div className="modern-input-wrapper">
                                    <i className="fa fa-user input-icon"></i>
                                    <input
                                        className="modern-input"
                                        placeholder="AD SOYAD"
                                        type="text"
                                        name="cardHolderName"
                                        value={this.state.formData.cardHolderName}
                                        onChange={this.handleInputChange}
                                        required
                                    />
                                  </div>
                                </div>

                                <div className="modern-form-group">
                                  <label className="modern-label">Kart Numarası</label>
                                  <div className="modern-input-wrapper">
                                    <i className="fa fa-credit-card input-icon"></i>
                                    <input
                                        className="modern-input"
                                        placeholder="1234 5678 9012 3456"
                                        type="text"
                                        name="cardNumber"
                                        value={this.state.formData.cardNumber}
                                        onChange={this.handleInputChange}
                                        maxLength="16"
                                        required
                                    />
                                    <div className="card-brands">
                                      <img src={visacard} alt="Visa" />
                                      <img src={mastercard} alt="Mastercard" />
                                    </div>
                                  </div>
                                </div>

                                <div className="form-row-modern">
                                  <div className="modern-form-group flex-2">
                                    <label className="modern-label">Son Kullanma Tarihi</label>
                                    <div className="expiry-wrapper">
                                      <select
                                          className="modern-select"
                                          name="expiryMonth"
                                          value={this.state.formData.expiryMonth}
                                          onChange={this.handleInputChange}
                                          required
                                      >
                                        <option value="">Ay</option>
                                        {numbers.map((number, index) => (
                                            <option key={index} value={number}>
                                              {String(number).padStart(2, '0')}
                                            </option>
                                        ))}
                                      </select>
                                      <span className="separator">/</span>
                                      <select
                                          className="modern-select"
                                          name="expiryYear"
                                          value={this.state.formData.expiryYear}
                                          onChange={this.handleInputChange}
                                          required
                                      >
                                        <option value="">Yıl</option>
                                        {years.map((number, index) => (
                                            <option key={index} value={number}>{number}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="modern-form-group flex-1">
                                    <label className="modern-label">
                                      CVV <i className="fa fa-question-circle" title="Kartınızın arkasındaki 3 haneli kod"></i>
                                    </label>
                                    <div className="modern-input-wrapper">
                                      <i className="fa fa-lock input-icon"></i>
                                      <input 
                                          className="modern-input"
                                          placeholder="123"
                                          type="text"
                                          name="cvc"
                                          value={this.state.formData.cvc}
                                          onChange={this.handleInputChange}
                                          maxLength="3"
                                          required
                                      />
                                    </div>
                                  </div>
                                </div>

                                {loading ? (
                                  <button className="modern-submit-btn" disabled={true}>
                                    <ReactLoading type="spin" color="#ffffff" width={'20px'} height={'20px'} />
                                    İşleniyor...
                                  </button>
                                ) : (
                                  <button className="modern-submit-btn" type="submit">
                                    <i className="fa fa-lock"></i>
                                    Güvenli Ödeme Yap
                                  </button>
                                )}

                                <div className="payment-security">
                                  <div className="security-item">
                                    <i className="fa fa-shield-alt"></i>
                                    <span>256-bit SSL Şifreleme</span>
                                  </div>
                                  <div className="security-item">
                                    <img src={iyzico} alt="iyzico" style={{height: '20px'}} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(Subsciption);
